import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InitialisePaymentPlanResult } from '../models/payment/initialise-payment-plan-result.model';
import { PaymentPlanDetails } from '../models/payment/payment-plan-details.model';
import { ValidatePaymentPlanResult } from '../models/payment/validate-payment-plan-result.model';
import { AppConfigService } from './app-config.service';
import { MerchantWarriorAddCardResult } from '../models/payment/merchant-warrior-add-card-result.model';
import { CreditCardDetails } from '../models/payment/credit-card-details.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentPlanService {

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public getPaymentPlanDetails(): Observable<PaymentPlanDetails> {
    return this.http.get<PaymentPlanDetails>(`${this.appConfigService.getConfig().apiUrl}debtor/paymentplan`);
  }

  public initialisePaymentPlan(data: any): Observable<InitialisePaymentPlanResult> {
    return this.http.post<InitialisePaymentPlanResult>(`${this.appConfigService.getConfig().apiUrl}debtor/paymentplan/initialise`, data);
  }

  // Note that this is only used for payment methods which don't utilise a redirect (hosted gateway)
  public createPaymentPlan(data: any): Observable<any> {
    return this.http.post<any>(`${this.appConfigService.getConfig().apiUrl}debtor/paymentplan`, data);
  }

  public validatePaymentPlan(data: any): Observable<ValidatePaymentPlanResult> {
    return this.http.post<ValidatePaymentPlanResult>(`${this.appConfigService.getConfig().apiUrl}debtor/paymentplan/validate`, data);
  }

  public merchantWarriorAddCard(url: string, merchantUUID: string, apiKey: string, cardName: string, cardNumber: string, cardExpiryMonth: string,
    cardExpiryYear: string, paymentCardCSC: string, payAttemptId: string): Observable<MerchantWarriorAddCardResult> {
    const body = {
      merchantUUID,
      apiKey,
      cardName,
      cardNumber,
      cardExpiryMonth,
      cardExpiryYear,
      paymentCardCSC,
      method: 'addCard',
      verifyCard: '1',
      custom1: payAttemptId
    };

    return this.http.post<MerchantWarriorAddCardResult>(url, body, { headers: {'MW-API-VERSION':'2.0','Content-Type':'application/json' }});
  }

  public merchantWarriorProcess(referenceId: string, cardDetails: CreditCardDetails): Observable<any> {
    const body = {
      referenceId,
      cardDetails
    };
    
    return this.http.post<any>(`${this.appConfigService.getConfig().apiUrl}debtor/paymentplan/merchantwarrior/process`, body);  
  }
}
